<ion-header>
  <ion-toolbar mode="md"
               color="dark">
    <ion-title>{{ 'payment.billToRoom' | transloco }}</ion-title>
    <ion-buttons slot="end">
      <ion-button mode="md"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="onCloseModal()">{{ 'common.close' | transloco }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content fullscreen>
  <div class="bill-to-room-payment">
    <div class="bill-to-room-payment__filter">
      <ion-input [placeholder]="'dining.searchDiner' | transloco"
                 min="2"
                 minlength="2"
                 debounce="500"
                 clearInput="true"
                 (ionChange)="searchingDiners($event)"></ion-input>
    </div>
    <!-- Diners to be updated when switching views-->
    <ion-list class="bill-to-room-payment__list"
              *ngIf="(diners$ | async) as diners">
      <ion-item *ngFor="let diner of diners "
                class="bill-to-room-payment__diner">
        <ion-avatar slot="start">
          <pos-avatar-control [value]="diner.photo"></pos-avatar-control>
        </ion-avatar>
        <ion-label class="bill-to-room-payment__diner__information">
          <h2><strong>{{diner.first_name}} {{diner.last_name}}</strong></h2>
          <span><strong>{{ 'dining.id' | transloco }}</strong> {{diner.client_id}}</span>
          <span><strong>{{ 'dining.liveLocation' | transloco }}</strong> {{diner.live_location}}</span>
        </ion-label>
        <ion-button mode="md"
                    color="dark"
                    debounce-click
                    [debounceTime]="0"
                    (debounceClick)="onAssignDiner(diner)">
          {{ 'common.use' | transloco }}
        </ion-button>
      </ion-item>
    </ion-list>
  </div>
</ion-content>
